import Agent from "../container/agent/Agent";
import AgentList from "../container/agent/AgentList";
import BackupList from "../container/backup/BackupList";
import Dashboard from "../container/dashboard/Dashboard";
import Investment from "../container/investment/Investment";
import Loan from "../container/loan/Loan";
import LoanList from "../container/loan/LoanList";
import LoansFormula from "../container/loans-formula/LoansFormula";
import Permission from "../container/permissions/Permission";
import PermissionList from "../container/permissions/PermissionList";
import ProfitChequeFormula from "../container/profit-loans-formula/ProfitChequeFormula";
import ProfitLoansFormula from "../container/profit-loans-formula/ProfitLoansFormula";
import LoanCountReport from "../container/reports/loan-count-report/LoanCountReport";
import Ticket from "../container/tickets/Ticket";
import TicketsInfo from "../container/tickets/TicketInfo";
import TicketList from "../container/tickets/TicketList";
import UserFormulaList from "../container/users-loans-formula/UserFormulaList";
import UserLoansFormula from "../container/users-loans-formula/UserLoansFormula";
import User from "../container/users/User";
import UserList from "../container/users/UserList";

export const routes = [
  {
    path: "/",
    component: <Dashboard />,
  },
  {
    path: "/agent-list",
    component: <AgentList />,
  },
  {
    path: "/agent/:id",
    component: <Agent />,
  },
  {
    path: "/agent",
    component: <Agent />,
  },
  {
    path: "/user",
    component: <User />,
  },
  {
    path: "/edit-user/:id",
    component: <User />,
  },
  {
    path: "/loan/:id",
    component: <Loan />,
  },
  {
    path: "/loan-list",
    component: <LoanList />,
  },
  {
    path: "/permission",
    component: <Permission />,
  },
  {
    path: "/permission/:id",
    component: <Permission />,
  },
  {
    path: "/permission-list",
    component: <PermissionList />,
  },
  {
    path: "/ticket",
    component: <Ticket />,
  },
  {
    path: "/ticket/:id",
    component: <TicketsInfo />,
  },
  {
    path: "/ticket-list",
    component: <TicketList />,
  },
  {
    path: "/user-list",
    component: <UserList />,
  },
  {
    path: "/loans-formula",
    component: <LoansFormula />,
  }, {
    path: "/user-loans-formula",
    component: <UserLoansFormula />,
  }, {
    path: "/user-loans-formula/:id",
    component: <UserLoansFormula />,
  }, {
    path: "/user-formula-list",
    component: <UserFormulaList />,
  },
  {
    path: "/investment-formula",
    component: <Investment />,
  },
  {
    path: "/profit-loans-formula",
    component: <ProfitLoansFormula />,
  },
  {
    path: "/profit-cheque-formula",
    component: <ProfitChequeFormula />,
  },
  {
    path: "/reports/loan-count-report",
    component: <LoanCountReport />,
  }, {
    path: "/backup-list",
    component: <BackupList />,
  },

];
